/**
 * User overrides for auto-detected terminal capabilities.
 * Detection is conservative (unknown terminals get hyperlinks/images off),
 * so settings let users force capabilities on or off.
 */

import type { TerminalCapabilities } from "@elyracode/tui";
import type { TerminalSettings } from "../../core/settings-manager.js";

/** Returns true if any capability override is set to a non-"auto" value. */
export function hasTerminalCapabilityOverrides(overrides: TerminalSettings): boolean {
	return (
		(overrides.hyperlinks !== undefined && overrides.hyperlinks !== "auto") ||
		(overrides.images !== undefined && overrides.images !== "auto") ||
		(overrides.trueColor !== undefined && overrides.trueColor !== "auto")
	);
}

/** Applies user capability overrides on top of detected capabilities. "auto"/undefined keeps detection. */
export function applyTerminalCapabilityOverrides(
	detected: TerminalCapabilities,
	overrides: TerminalSettings,
): TerminalCapabilities {
	const result: TerminalCapabilities = { ...detected };
	if (overrides.hyperlinks === "on") {
		result.hyperlinks = true;
	} else if (overrides.hyperlinks === "off") {
		result.hyperlinks = false;
	}
	if (overrides.trueColor === "on") {
		result.trueColor = true;
	} else if (overrides.trueColor === "off") {
		result.trueColor = false;
	}
	if (overrides.images === "off") {
		result.images = null;
	} else if (overrides.images === "kitty" || overrides.images === "iterm2") {
		result.images = overrides.images;
	}
	return result;
}
